export default __webpack_public_path__ + "static/media/home2.7d750908.jpg";